import { type SVGProps, useId } from "react";

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Close</title>
			<path
				d="M12 4L4 12M4 4L12 12"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
